"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALCULATE_RM_ZONES = void 0;
exports.CALCULATE_RM_ZONES = 'CALCULATE_RM_ZONES';
